import React from "react";

export const ReloadIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3 20.42C17.59 19.29 20.75 15.39 20.75 10.75C20.75 5.23 16.31 0.75 10.75 0.75C4.08 0.75 0.75 6.31 0.75 6.31M5.19 6.31H0.75V1.75M0.75 10.75C0.75 16.27 5.23 20.75 10.75 20.75"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
